export default __webpack_public_path__ + "static/media/03.79de6522.svg";